import { UpdateProfileDisplayNamePayload } from 'modules/auth/typings';

export const profileDisplayNameInitialValues: (
  firstName?: string,
  lastName?: string,
) => UpdateProfileDisplayNamePayload = (firstName = '', lastName = '') => ({
  firstName,
  lastName,
});
